import keyBy from 'lodash.keyby';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { AppState } from 'services/types';
import { WaterSourceState } from './types';

const selectWaterSource = (state: AppState): WaterSourceState =>
    state.waterSource;

const selectWaterSourceKeyedById = createDeepEqualSelector(
    selectWaterSource,
    waterSourceState => keyBy(waterSourceState, 'id')
);

export { selectWaterSource, selectWaterSourceKeyedById };
